import { render, staticRenderFns } from "./buildNewFile.vue?vue&type=template&id=6fdab12b&scoped=true"
import script from "./buildNewFile.vue?vue&type=script&lang=js"
export * from "./buildNewFile.vue?vue&type=script&lang=js"
import style0 from "./buildNewFile.vue?vue&type=style&index=0&id=6fdab12b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdab12b",
  null
  
)

export default component.exports